<template lang="pug">
.how-it-works
  h2.how-it-works__title {{ $t('pages.ssrGiftCards.how_it_works.title') }}
  h3.how-it-works__subtitle {{ $t('pages.ssrGiftCards.how_it_works.subtitle') }}
  .how-it-works__video
    iframe.how-it-works__video-iframe(
      :src="videoUrl"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
    )
</template>

<script>
export default {
  computed: {
    videoUrl () {
      return 'https://player.vimeo.com/video/892737581?h=4ef6c9fed3&color=F87900&title=0&byline=0&portrait=0'
    }
  }
}
</script>

<style lang="scss" scoped>
.how-it-works {
  display: flex;
  flex-direction: column;
  gap: $gap * 1.5;
  color: #ffffff;
  width: 100%;
  background-color: #2e1f42;
  border-radius: 8px;
  padding: $gap * 2.5;

  @include display-less(tablet) {
    padding: $gap;
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
  }

  &__subtitle {
    font-size: 16px;
    font-weight: 400;
  }

  &__video {
    position: relative;
    overflow: hidden;
    width: 100%;
    aspect-ratio: 16 / 9;
    max-width: 646px;
    margin: 0 auto;

    &-iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
